import { css } from '@emotion/css'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React, { useEffect, useRef } from 'react'
import { useLocation } from 'react-router'
import arrowLeft from '../../../assets/images/common/arrowLeft.svg'
import crossLight from '../../../assets/images/common/cross_light.svg'
import commonStyles from '../../../styles/commonStyles'
import { getStyles } from '../../../utils/utils/commonUtils'
import DrawerCircularProgress from '../DrawerCircularProgress/DrawerCircularProgress'

const ignorePaddingBottom = ['/service']

function RightDrawer({
  open,
  onClose,
  children,
  loading,
  backButtonClick,
  title,
  titleComp,
  onTop,
  isReportDetailsOpen,
}) {
  const classes = getStyles(commonStyles)
  const theme = useTheme()
  const location = useLocation()
  const timeoutId = useRef(null)

  const body = document.querySelector('body')
  // когда открывается окно отчетов дровер заявки исчезает
  // когда окно отчетов закрывается дровер появляется вновь
  const [isVisible, setIsVisible] = React.useState(false)
  useEffect(() => {
    if (isReportDetailsOpen) {
      timeoutId.current = setTimeout(() => {
        setIsVisible(!isVisible)
        if (body.style.overflow !== 'hidden') {
          body.style.overflow = 'hidden'
        }
      }, 300)
    } else {
      setIsVisible(false)
    }
  }, [isReportDetailsOpen])

  useEffect(() => {
    return () => clearTimeout(timeoutId.current)
  }, [])

  return (
    <Drawer
      name={'menu'}
      variant={'temporary'}
      anchor={'right'}
      open={!!open}
      onClose={onClose}
      BackdropProps={{
        className: css({ background: 'rgba(21, 21, 21, 0.2)' }),
      }}
      classes={{
        root: css({
          overflow: 'hidden',
          position: 'relative',
        }),
        paper: css({
          '&.MuiPaper-root': {
            width: 380,
            borderRight: 'none',
            boxShadow: '-4px 0px 4px rgba(0, 0, 0, 0.25)',
            height: '100%',
            paddingBottom: ignorePaddingBottom.includes(location.pathname)
              ? 0
              : '40px',
            [theme.breakpoints.down('sm')]: {
              width: '100%',
            },
          },
        }),
      }}
      sx={{
        zIndex: isReportDetailsOpen ? '0!important' : onTop ? 1202 : 1200,
        // стили появления и исчезновения дровера
        transition: 'opacity 0.3s',
        opacity: isReportDetailsOpen ? 0 : 1,
        visibility: isVisible ? 'hidden' : 'visible',
      }}
      id='right-drawer'
    >
      {title || titleComp ? (
        <Box name={'topbar'} className={css(classes.drawerTopBar)}>
          <Box className={'fx'}>
            {backButtonClick ? (
              <img
                alt={''}
                src={arrowLeft}
                className={'pointer'}
                onClick={backButtonClick}
              />
            ) : null}

            <Box ml={1.5} className={'aln-center'}>
              {titleComp ? (
                titleComp
              ) : (
                <Typography variant={'subtitle1'} color={'common.white'}>
                  {title}
                </Typography>
              )}
            </Box>
          </Box>

          <IconButton onClick={onClose}>
            <img alt={''} src={crossLight} />
          </IconButton>
        </Box>
      ) : null}

      <Box mt={'60px'} sx={{ height: '100%' }}>
        {children}
        {loading ? <DrawerCircularProgress /> : null}
      </Box>
    </Drawer>
  )
}

export default observer(RightDrawer)
